import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Box = styled.div`
  height: 100%;
  textarea {
    height: 100% !important;
    resize: none;
    border-color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
    width: 100%;
    border-radius: 4px;
    padding: ${props=>props.padding? props.padding : "1.34%"} 1.34%;
    &:focus {
      outline: none;
    }
  }
  .notice {
    margin-bottom: 8px;
    display: block;
    //padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
  }
`;
